/* eslint-disable import/no-unresolved */
import Vue from 'vue';
import Vuex from 'vuex';

import config from './config.module';
import payment from './payment.module';
import booking from './booking.module';
import property from './property.module';
import translation from './translation.module';

Vue.use(Vuex);

const modules = {
  config,
  payment,
  booking,
  property,
  translation,
};

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules,
});

export default store;
